// used in the user application list
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    programId: String,
    triggersId: String,
    emailTemplateId: String,
    placeholderMode: { type: String, default: "web"},
  }

  connect() {
    this.initEditorOptions()
    this.defaultEditorOptions = {
      semantic: false,
      tagsToRemove: ['script', 'link'],
      tagsToKeep: ['i', 'hr', 'img', 'embed', 'iframe', 'input'],
      autogrow: true,
      btns: [
        ['viewHTML2'],
        ['undo', 'redo'], // Only supported in Blink browsers
        ['formatting'],
        ['strong', 'em', 'del'],
        ['link'],
        ['insertImage', 'createButton'],
        ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
        ['unorderedList', 'orderedList'],
        ['horizontalRule'],
        ['removeformat'],
        ['quickPlaceholder', 'insertPlaceholder', 'verifyPlaceholders'],
        ['fullscreen']
      ]
    }
    this.current_editor = this.initEditor();
    this.updatePlaceholders();

    // Listen for reinit event
    this.element.addEventListener('trumbowyg:reinit', this.handleReinit.bind(this))
  }

  disconnect() {
    this.element.removeEventListener('trumbowyg:reinit', this.handleReinit.bind(this))
  }

  initEditorOptions() {
    this.initialEditorOptions = {}
    if (this.programIdValue) { this.initialEditorOptions.program_id = this.programIdValue }
    if (this.triggersIdValue) { this.initialEditorOptions.triggers_id = this.triggersIdValue }
    if (this.emailTemplateIdValues) { this.initialEditorOptions.email_template_id = this.emailTemplateIdValue }
    if (this.placeholderModeValue) { this.initialEditorOptions.placeholderMode = this.placeholderModeValue }
  }

  initEditor(initialEditorOptions = {}, plugin_options = {}, force = false) {
    // merge editor_options
    var editor_options = this.defaultEditorOptions;
    editor_options.plugins = plugin_options;
    editor_options.extra = this.initialEditorOptions;

    var $trumbowyg_box = $(this.element)
    var $textarea = $trumbowyg_box.find('textarea')

    if ($textarea.data('trumbowyg')) {
      $textarea.trumbowyg('destroy');
    }

    var $editor = $textarea.trumbowyg(editor_options);

    $editor.on('tbwtoggle', function(e) {
      if ($trumbowyg_box.find(".trumbowyg-viewHTML2-button").hasClass('trumbowyg-active')) {
        // Active means seeing the code view
        // Replacements done here must be reflected in ApplicationController#convert_param_from_placeholder_span_to_placeholder_token
        var html_content = $editor.trumbowyg('html');
        $editor.trumbowyg('html',
          html_content
            .replace(/<a [^<>]*class="placeholder-token"[^<>]*>((?:<b>|<i>|<strike>)*)([A-Z_][\w\-]*)\s*(?:&nbsp;)?((?:<\/b>|<\/i>|<\/strike>)*)\<\/a>/gi, '$1{$2}$3')
            .replace(/<a href="([^"<>]*)%7B([A-Z_][\w\-]*)%7D([^"<>]*)"([^<>]*)>/gi, '<a href="{$2}$3"$4>')
        );
      } else {
        replace_placeholder_token($('[contenteditable="true"]'));
      }
    });

    $editor.on('tbwchange tbwblur tbwpaste', function(e) {
      // Sync Trumbowyg content back to the textarea
      var content = $editor.trumbowyg('html');
      if (content) {
        $textarea.val(content);
      }

      // Dispatch native input event for Vue to pick up
      var nativeTextarea = $textarea[0]; // Get the native DOM element
      nativeTextarea.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // Also sync on focus out from the editor
    $editor.on('tbwclose', function(e) {
      var content = $editor.trumbowyg('html');
      if (content) {
        $textarea.val(content);
      }

      // Dispatch native input event for Vue to pick up
      var nativeTextarea = $textarea[0]; // Get the native DOM element
      nativeTextarea.dispatchEvent(new Event('input', { bubbles: true }));
    });

    $editor.on('tbwinit', function(e) {
      replace_placeholder_token($('[contenteditable="true"]'));
    });

    // When the full screen is open, this will unset the position of the admin sidebar so it doesn't overlap the editor.
    $editor.on('tbwopenfullscreen', function(){
      var adminSectionID = document.getElementById('admin-main-section');
        adminSectionID.style.position = 'unset';
    })

    // When the full screen is closed, this will set the position of the admin sidebar back to relative.
    $editor.on('tbwclosefullscreen', function(){
      var adminSectionID = document.getElementById('admin-main-section');
        adminSectionID.style.position = 'relative';
    });

    // Have the cursor focus on the input element when the insert placeholder modal opens.
    // TODO: Not sure why this is being called twice, and also not sure why the click listener is not working

    $trumbowyg_box.find(".trumbowyg-insertPlaceholder-button").on('click', function() {
      setTimeout(() => {
        $('#placeholder-multiselect-container').click()
      }, 1000)
    });

    return $editor;
  }

  updatePlaceholders() {
    const self = this

    $.ajax({
      type: 'get',
      url: '/admin/utilities/placeholders',
      dataType: 'json',
      data: this.initialEditorOptions,
      success: function(data) {
        self.reloadEditor(
          self.initialEditorOptions,
          {
            quickPlaceholder: {
              label: 'Placeholders',
              source: data,
              formatDropdownItem: function (item) {
                // This is the "simple" dropdown
                return '<div><h4>' + item.name + '</h4><p class="title">' + item.title + '</p></div>';
              },
              formatResult: function (item) {
                var placeholder = item.name;
                if (placeholder.includes("_URL") || placeholder.includes("_LINK") || item.title.includes("URL")) {
                  return `<a href="{${placeholder}}">Click here</a>`;
                } else {
                  return `<a href="#" class="placeholder-token">${placeholder}&nbsp;</a>`;
                }
              }
            }
          }
        );
      }
    });
  }

  reloadEditor(initialEditorOptions, plugin_options = {}) {
    if (this.current_editor !== undefined && this.current_editor != null) {
      this.current_editor.trumbowyg('destroy');
    }
    this.current_editor = this.initEditor(initialEditorOptions, plugin_options, true);
  }

  handleReinit(event) {
    const content = event.detail.content
    if (this.current_editor) {
      this.current_editor.trumbowyg('html', content)
    }

    this.updatePlaceholders();
  }

  disconnect() {
    if (this.current_editor) {
      this.current_editor.trumbowyg('destroy');
    }
    this.element.removeEventListener('trumbowyg:reinit', this.handleReinit.bind(this))
  }
}
